import { SelectMenu } from '@/components/select-menu';
import { Button } from '@/components/button';
import type { SyntheticEvent } from 'react';
import { useGenerateRefine } from '@/hooks/use-generate-refine';

const formattingOptions = [
  { value: 'trim', label: 'Trim' },
  { value: 'professional', label: 'Make sound more professional' },
  { value: 'toenglish', label: 'Translate to english' },
  { value: 'togerman', label: 'Translate to german' },
];

export function RefineForm({
  nodeFormData,
  onSuccess,
}: {
  nodeFormData: any;
  onSuccess: (data: any) => void;
}) {
  const refineMutation = useGenerateRefine();

  const handleRefine = (event: SyntheticEvent) => {
    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const formData = new FormData(target);
    const action = (formData.get('refineSelect[value]') ?? '') as string;

    const refineData = {
      formData: nodeFormData,
      action,
    };

    refineMutation.mutate(refineData, {
      onSuccess,
    });
  };

  return (
    <div>
      <form onSubmit={handleRefine}>
        <div className="flex items-end space-x-2">
          <div className="flex-1">
            <SelectMenu
              label=""
              options={formattingOptions}
              name="refineSelect"
              selected={formattingOptions[0]}
            />
          </div>
          <Button
            type="submit"
            variant="tertiary"
            loading={refineMutation.isLoading}
          >
            Apply
          </Button>
        </div>
      </form>
    </div>
  );
}
